var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "-15 -15 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0,
    d: "M-15 35h50v-50h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M9.995 20a.714.714 0 0 1-.704-.714V6.721l-4.493 4.493a.714.714 0 0 1-1.01-1.01l5.713-5.712.008-.007.001-.001a.703.703 0 0 1 .022-.02v-.002l.03-.025.001-.001.019-.014.002-.001.034-.024.003-.002a.336.336 0 0 1 .025-.016l.004-.002.029-.016.004-.002a.207.207 0 0 1 .025-.012l.005-.001.028-.014.005-.001c.007-.004.02-.007.032-.012l.005-.001a.485.485 0 0 1 .025-.009l.005-.001.032-.008h.004a.285.285 0 0 1 .03-.007h.004a.445.445 0 0 1 .03-.005h.004a.393.393 0 0 1 .034-.004h.002a.659.659 0 0 1 .037-.001h.035c.022 0 .043.002.063.004h-.003l.01.001h-.005a.659.659 0 0 1 .048.007h-.004l.039.008-.005-.001a.566.566 0 0 1 .032.008l-.005-.001.047.014-.005-.001c.014.004.022.008.03.011l-.003-.002c.017.007.03.012.041.018l-.004-.002.058.03-.004-.003.005.003-.003-.001c.017.009.03.018.043.026l-.002-.001.03.02-.002-.001a.82.82 0 0 1 .047.037l.004.004.033.03 5.711 5.71a.714.714 0 0 1-.498 1.226h-.022.002a.713.713 0 0 1-.491-.215L10.719 6.72v12.565c0 .394-.32.713-.714.713h-.01V20zM.724 1.428h-.01A.714.714 0 1 1 .714 0H19.296a.714.714 0 1 1 0 1.428H.724z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNew);
export default __webpack_public_path__ + "static/media/upload-new.5806a5048f31e2700589f3bdb8f8d0d2.svg";
export { ForwardRef as ReactComponent };